import { EventDispatcher } from "../../../core/internal/event/EventDispatcher"
import UserEvent from "../../../core/internal/event/UserEvent"
import { EventTransport } from "../../../core/internal/event/EventTransport"

export class NodeEventDispatcher implements EventDispatcher {
  constructor(private readonly transport: EventTransport) {}

  async dispatch(events: UserEvent[], sync: boolean): Promise<void> {
    const dto = events.map((it) => it.toDto())
    await this.transport.send(dto)
  }
}
